export default {
  origin: `https://valkdemo.dealroom-app.cf`,
  url: "https://valk-api-test-v2.cf",
  domain: ".dealroom-app.com",
  logoStyles: {},
};
